import React from 'react';
import Checkbox from '@atlaskit/checkbox';
import { components } from '@atlaskit/select';
import { useIntl } from '@atlassian/jira-intl';
import type { MenuProps } from '@atlassian/jira-issue-field-select-base';
import { isEpicLinkFieldRenamedToParent } from '../../../feature-flags';
import messages from './messages';
import { CheckboxWrapper, CheckboxLabel } from './styled';

type Props = MenuProps;

const Menu = (props: Props) => {
	const { formatMessage } = useIntl();
	const { children, ...restProps } = props;

	const isChecked = props.selectProps?.componentsProps?.isChecked || false;
	const label = isEpicLinkFieldRenamedToParent()
		? formatMessage(messages.checkboxLabelRenamedParent)
		: formatMessage(messages.checkboxLabel);

	return (
		// @ts-expect-error - TS2746 - This JSX tag's 'children' prop expects a single child of type 'ReactElement<any, string | JSXElementConstructor<any>>', but multiple children were provided.
		<components.Menu {...restProps}>
			<CheckboxWrapper onClick={props.selectProps?.componentsProps?.onChange}>
				<Checkbox
					isChecked={isChecked}
					size="medium"
					testId="issue-field-epic-link.ui.edit.menu.issue-field-epic-link-checkbox"
				/>
				<CheckboxLabel>{label}</CheckboxLabel>
			</CheckboxWrapper>
			{children}
		</components.Menu>
	);
};

export default Menu;
